import { request } from "../@utils";
import { requestFile } from "../@utils";
const categoryService = {
  getCategoryDetail: async (params) => {
    const res = await request.post('/category/detail',{ data: params })
    return res;
  },
  getCategoryPageList: async (params) => {
    const res = await request.post('/category/page',{ data: params })
    return res;
  },
  exportCategory: async (params) => {
    const res = await requestFile.post('/category/export',{ data: params, responseType: "blob"  })
    return res;
  }
};
export default categoryService;